module.exports = {"type":"post","category":"life","title":"Graduation day","date":"2015-11-07T23:46:37.121Z","path":"/2015/11/07/graduation-day","body":"<p><img src=\"./graduation_day.jpg\" alt=\"Graduation day\"></p>\n"}


//////////////////
// WEBPACK FOOTER
// ./2015-11-07-graduation-day/index.md
// module id = 549
// module chunks = 0